<template>


        <div class="relatorios">

            <el-form label-position="top">
                <c-panel title="FILTROS">

                    <div>
                        <el-row :gutter="10" class="u-mt-10">
                            <el-col :xs="24" :sm="20" :md="20">
                                <el-form-item label="Instituição" key="instituicao" v-if="$store.state.user.tipo == 10 || ($store.state.user.tipo > 3 && $store.state.user.tipo <= 8)">
                                    <el-select @change="loadingTurmas" ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                                        <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <div class="style-form" v-if="$store.state.user.tipo <= 3 || $store.state.user.tipo == 9">
                                    <label class="el-form-item__label">Instituição</label>
                                    <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4">
                                <el-form-item label="Período Letivo" key="periodo">
                                    <el-select @change="loadingTurmas" ref="periodo_letivo_id" v-model="filtro.periodo_letivo_id">
                                        <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">                    
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item key="turma_id">
                                    <el-select v-model="filtro.turma_id" filterable placeholder="Turma">
                                        <el-option-group
                                            v-for="(grupo, i) in turmas"
                                            :key="i"
                                            label="">
                                        <el-option
                                            v-for="turma in grupo"
                                            :key="turma.id"
                                            :label="`${turma.curso.nome} ${turma.nome}`"
                                            :value="turma.id">
                                        </el-option>
                                        </el-option-group>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row> 

                    </div>

                </c-panel>
            </el-form>

            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button @click="renderRelatorioResultadosFinais('excel')" :loading="loadingButtonExcel" type="primary">EXCEL</el-button>
                        <el-button @click="renderRelatorioResultadosFinais('word')" :loading="loadingButtonWord" type="primary">WORD</el-button>
                        <el-button @click="renderRelatorioResultadosFinais('pdf')" :loading="loadingButtonPdf" type="primary">PDF</el-button>
                        <el-button @click="renderRelatorioResultadosFinais('html')" :loading="loadingButtonHtml" type="primary">HTML</el-button>
                    </el-col>
                </el-row>
            </div>

        </div>


</template>
<script>

export default {
    data: () => ({
        loadingButtonExcel: false,
        loadingButtonWord: false,
        loadingButtonPdf: false,
        loadingButtonHtml: false,
        ref: [],
        filtro: {
            periodo_letivo_id: '',
            instituicao_id: '',
            turma_id: ''
        },
        turmas: [],
        campos:{
            aluno: [
                'nome',
                'data_nascimento',
                'municipioNascimento',
                'mae',
                'pai',
                'endereco'
            ],
            matricula: [
                'situacao_academica'
            ]
        }

    }),
    mounted () {

        this.filtro.periodo_letivo_id = this.$store.state.config.periodo.id;

        if(this.$store.state.user.tipo <= 3 || this.$store.state.user.tipo == 9){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }

        this.loadingTurmas();
    },
    methods: {
        loadingTurmas() {

            this.filtro.turma_id = '';

            if(!this.filtro.instituicao_id && this.$store.state.config.instituicao){
                this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
            }

            if(!this.filtro.instituicao_id) {
                return;
            }            

            let p = this.filtro.periodo_letivo_id;
            let i = this.filtro.instituicao_id;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${i}/${p}`, this.$store.getters.getHeaderAuth).then(response => {

                this.turmas = response.data;                

            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        renderRelatorioResultadosFinais(tipo){

            if(!this.filtro.instituicao_id) {
                window.eventBus.$emit('alert', {msg: 'Por favor, selecione uma instituição', type: 'warning'});
                return;
            }

            if(tipo == 'pdf'){

                this.loadingButtonPdf = true;
                this.renderPdfRelatorioResultadosFinais();

            }else if(tipo == 'html'){

                this.loadingButtonHtml = true;
                this.renderHtmlRelatorioResultadosFinais();

            }else if(tipo == 'word'){

                this.loadingButtonWord = true;
                this.renderWordRelatorioResultadosFinais();

            }else if(tipo == 'excel'){

                this.loadingButtonExcel = true;
                this.renderExcelRelatorioResultadosFinais();
            }
        },
        renderExcelRelatorioResultadosFinais(){

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioResultadosFinais/excel`, { param: {filtros: this.filtro, campos: this.campos} }, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.loadingButtonExcel = false;

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.xlsx');
                document.body.appendChild(link);
                link.click();

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        renderWordRelatorioResultadosFinais(){

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioResultadosFinais/word`, { param: {filtros: this.filtro, campos: this.campos} }, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.loadingButtonWord = false;

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.docx');
                document.body.appendChild(link);
                link.click();

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        renderPdfRelatorioResultadosFinais(){

            window.eventBus.$emit('print', {url: '/api/pdf/renderRelatorioResultadosFinais/pdf', param: { filtros: this.filtro, campos: this.campos }});
            this.loadingButtonPdf = false;
        },
        async renderHtmlRelatorioResultadosFinais(){

            try{

                let response = await this.getCodAutorizacaoRelatorioHtml();

                window.open(`${process.env.VUE_APP_BASE_URL}/api/relatorio/open/${response.data.token}`);

                this.loadingButtonHtml = false;

            }catch(e){

                window.eventBus.$emit('alert', {msg: 'Erro ao gerar relatório.', type: 'warning'});
            }

        },
        getCodAutorizacaoRelatorioHtml(){

            return this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio/generateCodAutorizacaoPrintHtml/resultados-finais`, {filtros: this.filtro, campos: this.campos}, this.$store.getters.getHeaderAuth);
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA

            if(!this.filtro[field])
                return false;

            if(size && this.filtro[field].length < size)
                this.filtro[field] = '';

            this.filtro[field] = this.filtro[field].toUpperCase();

            this.filtro[field] = this.$removerAcentos(this.filtro[field]);
        }
    }
}
</script>